const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';

export const API_BASE_URL = isDevelopment
    ? 'http://localhost:5211'
    : 'https://x-consulting-backend.onrender.com';

// console.log('🌍 Environment:', process.env.NODE_ENV);
// console.log('🔗 API URL:', API_BASE_URL);